import React from "react";
import "./Below_Banner_section.css";
import { useNavigate } from "react-router-dom";

function Below_Banner_section({ headingText, ContentText }) {

  const navigate = useNavigate()

  return (
    <section className="Below_Banner_section">
      <div className="container">
        <h3 className="">{headingText}</h3>
        <p>{ContentText}</p>
        <div className="KNOW_MORE_text">
          <span onClick={() => {navigate("/about-us")}}>KNOW MORE</span>
        </div>
      </div>
    </section>
  );
}

export default Below_Banner_section;
